import React from 'react';
import { Helmet } from 'react-helmet-async';

import Hero from '../Hero/Hero';
import About from '../About/About';
import Work from '../Work/Work';
import Contact from '../Contact/Contact';

import data from '../../Utils/data';

/**
 * The scroll narrative.
 *
 * Four acts, four distinct layout families, in a deliberate order:
 *   1. Hero     asymmetric split, live object
 *   2. About    offset editorial, heavy negative space
 *   3. Work     bento of project cards
 *   4. Contact  centred close
 *
 * Each act also has its own route so deep links and search results keep
 * working. The section components render their own <Helmet> only when
 * mounted standalone, so this page owns the document head by itself.
 */
function Home() {
  return (
    <>
      <Helmet>
        <title>Damilare Oyedeji, Software Engineer</title>
        <meta
          name="description"
          content="Software engineer building scalable systems and fluid interfaces with React, Node.js and React Native. Six years across fintech, edtech, SaaS and mobile."
        />
      </Helmet>

      <Hero personal={data.personal} />
      <About data={data.about} />
      <Work data={data.selectedWork} />
      <Contact data={data.contact} personal={data.personal} />
    </>
  );
}

export default Home;
